export default __webpack_public_path__ + "static/media/reactBootstrap.ffcbb814.PNG";